import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty';
import React, { ReactNode } from 'react';
import { useEditModeContext } from './EditModeContextPlugin';

interface Props {
  placeholder: ReactNode;
}

export const PlaceholderPlugin: React.FunctionComponent<Props> = ({ placeholder }) => {
  const [editor] = useLexicalComposerContext();
  const isEmpty = useLexicalIsTextContentEmpty(editor);
  const editMode = useEditModeContext();

  return !editMode && isEmpty ? <>{placeholder}</> : null;
};
